export type SectionRowMode = "list" | "branches" | "merged_lists";

export interface SectionRowDefinition {
  label: string;
  mode: SectionRowMode;
  path?: readonly string[];
  paths?: readonly (readonly string[])[];
}

export interface SectionDefinition {
  title: string;
  rows: readonly SectionRowDefinition[];
}

export const PROFILE_SECTION_DEFINITIONS: readonly SectionDefinition[] = [
  {
    rows: [
      {
        label: "Responsibilities",
        mode: "list",
        path: ["identity", "responsibilities"],
      },
      { label: "Consumers", mode: "list", path: ["identity", "consumers"] },
    ],
    title: "Identity",
  },
  {
    rows: [
      { label: "Patterns", mode: "list", path: ["architecture", "patterns"] },
      {
        label: "Protocols",
        mode: "list",
        path: ["architecture", "communication", "protocols"],
      },
      {
        label: "Styles",
        mode: "list",
        path: ["architecture", "communication", "styles"],
      },
      {
        label: "Deployment Model",
        mode: "list",
        path: ["architecture", "deployment_model"],
      },
    ],
    title: "Architecture",
  },
  {
    rows: [
      {
        label: "Primary Languages",
        mode: "list",
        path: ["stack", "languages", "primary"],
      },
      {
        label: "Supporting Languages",
        mode: "list",
        path: ["stack", "languages", "supporting"],
      },
      { label: "Runtimes", mode: "list", path: ["stack", "runtimes"] },
      { label: "Frameworks", mode: "list", path: ["stack", "frameworks"] },
      { label: "Libraries", mode: "list", path: ["stack", "libraries"] },
    ],
    title: "Stack",
  },
  {
    rows: [
      { label: "API Styles", mode: "list", path: ["api", "styles"] },
      { label: "Endpoints", mode: "list", path: ["api", "endpoints"] },
      {
        label: "Authentication",
        mode: "list",
        path: ["api", "authentication"],
      },
      { label: "Authorization", mode: "list", path: ["api", "authorization"] },
      { label: "Providers", mode: "list", path: ["integrations", "providers"] },
      {
        label: "Incoming Webhooks",
        mode: "list",
        path: ["integrations", "webhooks", "incoming"],
      },
      {
        label: "Outgoing Webhooks",
        mode: "list",
        path: ["integrations", "webhooks", "outgoing"],
      },
    ],
    title: "API & Integrations",
  },
  {
    rows: [
      {
        label: "Package Tools",
        mode: "list",
        path: ["tooling", "package_management", "tools"],
      },
      {
        label: "Build Tools",
        mode: "list",
        path: ["tooling", "build_system", "tools"],
      },
      {
        label: "Build Commands",
        mode: "list",
        path: ["tooling", "build_system", "commands"],
      },
      {
        label: "Test Commands",
        mode: "merged_lists",
        paths: [
          ["tooling", "testing_commands", "unit"],
          ["tooling", "testing_commands", "integration"],
        ],
      },
      {
        label: "Lint Commands",
        mode: "list",
        path: ["tooling", "testing_commands", "linting"],
      },
      {
        label: "Cloud Services",
        mode: "list",
        path: ["infrastructure", "cloud", "platform_services"],
      },
      {
        label: "Databases",
        mode: "list",
        path: ["infrastructure", "data", "databases"],
      },
      {
        label: "Caches",
        mode: "list",
        path: ["infrastructure", "data", "caches"],
      },
      {
        label: "Storage",
        mode: "list",
        path: ["infrastructure", "data", "storage"],
      },
      {
        label: "Monitoring",
        mode: "list",
        path: ["operations", "observability", "monitoring"],
      },
      {
        label: "CI/CD Strategies",
        mode: "list",
        path: ["operations", "ci_cd", "strategies"],
      },
    ],
    title: "Tooling & Operations",
  },
  {
    rows: [
      {
        label: "Active Branches",
        mode: "branches",
        path: ["development", "active_branches"],
      },
      {
        label: "Testing Frameworks",
        mode: "list",
        path: ["development", "testing", "frameworks"],
      },
      {
        label: "Documentation Locations",
        mode: "list",
        path: ["development", "documentation", "locations"],
      },
    ],
    title: "Development",
  },
];
